<mat-toolbar class="custom-header">
  <span (click)="closeModal()">
    <mat-icon svgIcon="mat:arrow_back"></mat-icon>
  </span>
</mat-toolbar>
<div class="container">
  <h2>{{"PROFILE.NUTRITION.MEAL-PLAN-INFOS.MEASUREMENTS" | translate}}</h2>

  <div class="meas-container" *ngIf="measurements">
    <div class="meas" *ngFor="let item of measurements; let i = index">
      <div class="datas">
        <div class="info-box">
          <p class="data-label">{{'PROFILE.NUTRITION.SURVEY.'+item.unitSystem+'.WEIGHT' | translate}}</p>
          <p class="data">{{item.weight}}</p>
        </div>
        <div class="info-box">
          <p class="data-label">{{'PROFILE.NUTRITION.SURVEY.'+item.unitSystem+'.WAIST' | translate}}</p>
          <p class="data">{{item.weistline}}</p>
        </div>
        <div class="info-box">
          <p class="data-label">{{'PROFILE.NUTRITION.SURVEY.'+item.unitSystem+'.FLANKS' | translate}}</p>
          <p class="data">{{item.hip}}</p>
        </div>
        <div class="info-box">
          <p class="data-label">{{'PROFILE.NUTRITION.SURVEY.'+item.unitSystem+'.THIGH_SHORT' | translate}}</p>
          <p class="data">{{item.leftThigh}} {{item.rightThigh}}</p>
        </div>
        <div class="info-box" style="margin: 0;">
          <p class="data-label">{{'PROFILE.NUTRITION.SURVEY.'+item.unitSystem+'.ARM_SHORT' | translate}}</p>
          <p class="data">{{item.leftArm}} {{item.rightArm}}</p>
        </div>
      </div>
      <div class="date">
        <span>
          {{item.creationDate | date: guiService.dateFormat}}
        </span>
        <div class="line" *ngIf="i > 0"></div>
      </div>
    </div>
  </div>
  <div class="meas-container" *ngIf="!measurements">
    <div class="meas">
      <ion-skeleton-text style="height: 335px;" class="datas" [animated]="true"></ion-skeleton-text>
      <ion-skeleton-text style="height: 21px;" class="date" [animated]="true"></ion-skeleton-text>
    </div>
    <div class="meas">
      <ion-skeleton-text style="height: 335px;" class="datas" [animated]="true"></ion-skeleton-text>
      <ion-skeleton-text style="height: 21px;" class="date" [animated]="true"></ion-skeleton-text>
    </div>
    <div class="meas">
      <ion-skeleton-text style="height: 335px;" class="datas" [animated]="true"></ion-skeleton-text>
      <ion-skeleton-text style="height: 21px;" class="date" [animated]="true"></ion-skeleton-text>
    </div>
  </div>
</div>
